<template>
  <div>
    <div class="pc-footer">
      <div class="footer-top">
        <div class="footer-logo">
          <a href="/">
            <img src="../../../assets/img/footer/logo_colorful.png" alt />
          </a>
        </div>
        <div class="footer-links-container">
          <ul class="footer-navs">
            <li
              class="footer-nav-item"
            >
              <div class="footer-nav-title" v-text="$t('menu.buy_mix')"></div>
              <div class="buy-mix-dropdown-box">
                <ul class="buy-mix-list">
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.bybit.com/en-US/trade/spot/MIX/USDT" target="_blank">Bybit</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://en.bithumb.com/trade/order/MIX_KRW" target="_blank">Bithumb</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.mexc.com/exchange/MIX_USDT" target="_blank">MEXC</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-tab" href="#">Gate.io</a>
                    <ul class="buy-mix-second-list">
                      <li class="buy-mix-second-list-item">
                        <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_USDT" target="_blank">USDT</a>
                        <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_ETH" target="_blank">ETH</a>
                      </li>
                    </ul>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://ascendex.com/en/cashtrade-spottrading/usdt/mix" target="_blank">AscendEX</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-tab" href="#">Hotbit</a>
                    <ul class="buy-mix-second-list">
                      <li class="buy-mix-second-list-item">
                        <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_USDT" target="_blank">USDT</a>
                        <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_BTC" target="_blank">BTC</a>
                      </li>
                    </ul>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.bitglobal.com/en-us/spot/trade?q=MIX-USDT" target="_blank">BitGlobal</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://pancakeswap.finance/info/token/0x398f7827dccbefe6990478876bbf3612d93baf05" target="_blank">PancakeSwap</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://app.uniswap.org/" target="_blank">Uniswap</a>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="footer-nav-item"
              @click.prevent="anchor('products')"
            >
              <div class="footer-nav-title" v-text="$t('menu.products')"></div>
            </li>
            <li
              class="footer-nav-item"
              @click.prevent="anchor('information')"
            >
              <div class="footer-nav-title" v-text="$t('menu.information')"></div>
            </li>
            <li class="footer-nav-item" @click.prevent="anchor('about')">
              <div class="footer-nav-title" v-text="$t('menu.about')"></div>
            </li>
            <li
              class="footer-nav-item"
              @click.prevent="anchor('community')"
            >
              <div class="footer-nav-title" v-text="$t('menu.joincommunity')"></div>
            </li>
          </ul>
          <div class="social-links">
            <a
              class="social-link-item facebook-icon"
              title="Facebook"
              href="https://www.facebook.com/mixmarvelplatform"
              target="_blank"
            ></a>
            <a
              class="social-link-item twitter-icon"
              title="Twitter"
              href="https://twitter.com/MIXMARVELGAME"
              target="_blank"
            ></a>
            <a class="social-link-item ins-icon" title="Ins" href="https://www.instagram.com/mixmarvelgame/" target="_blank"></a>
            <a
              class="social-link-item medium-icon"
              title="Medium"
              href="https://medium.com/mixmarvel-official-blog"
              target="_blank"
            ></a>
            <a
              class="social-link-item youtube-icon"
              title="Youtube"
              href="https://www.youtube.com/channel/UCmXHR_CEEGB91IpritzrJlA"
              target="_blank"
            ></a>
            <a
              class="social-link-item reddit-icon"
              title="Reddit"
              href="https://www.reddit.com/r/MIXMARVEL/"
              target="_blank"
            ></a>
            <a
              class="social-link-item email-icon"
              title="Email"
              href="mailto:contact@mixmarvel.com"
            ></a>
          </div>
        </div>
      </div>
      <div class="footer-bottom" v-html="$t('copy_right')"></div>
    </div>
    <div class="wap-footer">
      <div class="icon-links">
        <a class="icon-link-item facebook-icon" href="https://www.facebook.com/mixmarvelplatform"></a>
        <a class="icon-link-item twitter-icon" href="https://twitter.com/MIXMARVELGAME"></a>
        <a class="icon-link-item ins-icon" href="https://www.instagram.com/mixmarvelgame/"></a>
        <a class="icon-link-item medium-icon" href="https://medium.com/mixmarvel-official-blog"></a>
        <a class="icon-link-item youtube-icon" href="https://www.youtube.com/channel/UCmXHR_CEEGB91IpritzrJlA"></a>
        <a class="icon-link-item robot-icon" href="https://www.reddit.com/r/MIXMARVEL/"></a>
        <a class="icon-link-item email-icon" title="Email" href="mailto:contact@mixmarvel.com"></a>
      </div>
      <div class="copy-rights" v-html="$t('wap_copy_right')">
      </div>
    </div>
  </div>
</template>

<script>
import global from "../common/common";
export default {
  data() {
    return {
      isHome: true
    };
  },
  created() {
    var currentPath = this.$route.path;
    if (currentPath != "/") {
      this.isHome = false;
    }
  },
  methods: {
    anchor(id) {
      //跳转到对应的section
      if (this.isHome) {
        var selector = "#" + id;
        var scrollH = $(selector).offset().top;
        $("html,body").animate({ scrollTop: scrollH - 70 }, 1000);
      } else {
        this.$cookies.set("anchor", id);
        window.location.href = "/";
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pc/template/FooterCommon.vue